import { css, styled } from '@styles/theme'

export const questionsStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),

	title: css({
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: '19px',
	}),
	buttons: css({
		display: 'flex',
		width: '100%',
		maxWidth: '347px',
	}),
	gridFilter: css({
		display: 'grid',
		gridTemplateColumns: 'repeat(4, 1fr)',
		gridTemplateAreas: `'search code matter subMater'
		'year code jury institution'`,
		gap: '23px',
		marginTop: '28px',
	}),

	tagsContainer: css({
		marginTop: '32px',
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
	}),

	tagRow: css({
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
	}),

	ContainerActionsFilter: styled('div', {
		display: 'flex',
		justifyContent: 'flex-end',
		flexWrap: 'wrap',
		gap: '14px',

		variants: {
			filter: {
				true: {
					justifyContent: 'space-between',
				},
			},
		},
	}),
	containerActions: css({
		display: 'flex',
		gap: '32px',
	}),

	buttonSave: css({
		display: 'flex',
		alignItems: 'center',
		width: '120px',
		gap: '8px',
		color: '$neutral160',

		_font: 'normal',
		fontWeight: '400',
		fontSize: '16px',
		lineHeight: '21px',
		cursor: 'pointer',

		svg: {
			width: '24px',
			height: '24px',
		},
	}),
	buttonClear: css({
		display: 'flex',
		alignItems: 'center',
		width: '124px',
		gap: '8px',
		color: '$red',

		_font: 'normal',
		fontWeight: '400',
		fontSize: '16px',
		lineHeight: '21px',
		cursor: 'pointer',

		svg: {
			width: '24px',
			height: '24px',
		},
	}),

	questionsMenu: css({
		display: 'flex',
		gap: '40px',
		alignItems: ' center',
		justifyContent: 'space-between',
		padding: '0px 54px  0px 16px',
		height: '84px',

		background: '$neutral20',
		border: '1px solid $neutral50',
		borderRadius: '12px',
	}),

	questionsNumber: css({
		display: 'flex',
		gap: '16px',
		alignItems: ' center',
		width: '100%',
		maxWidth: '248px',

		h6: {
			_font: 'normal',
			fontWeight: '500',
			fontSize: '$md',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '$neutral150',
		},

		p: {
			_font: 'normal',
			fontWeight: '400',
			fontSize: '$md',
			lineHeight: '20px',
			letterSpacing: '0.05em',
			color: '$neutral90',
		},
	}),

	buttonIcon: css({
		cursor: 'pointer',
		color: '$neutral130',

		'&:hover': {
			color: '$primary',
		},
	}),

	containerButtonNextPage: css({
		display: 'flex',
		justifyContent: 'center',
		gap: '29px',
		marginBottom: '80px',

		button: {
			maxWidth: '178px',
		},
	}),

	ContainerFocus: styled('div', {
		variants: {
			open: {
				true: {
					display: 'block',
				},
				false: {
					display: 'none',
				},
			},
		},
	}),

	buttonsFocus: css({
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: '32px',
		marginBottom: '71px',
	}),

	containerPrint: css({
		display: 'none',

		'&@media all': {
			'page-break': {
				display: 'none',
			},
		},

		'&@media print': {
			'html, body': {
				height: 'initial !important',
				overflow: 'initial !important',
				'-webkit-print-color-adjust': 'exact',
			},
			'page-break': {
				marginTop: '1rem',
				display: 'block',
				pageBreakBefore: 'auto',
			},
		},

		'&@page': {
			size: 'auto',
			margin: '20mm',
		},
	}),

	showFilterContainer: css({
		width: '100%',
		display: 'flex',
		justifyContent: 'end',
	}),

	showFilter: css({
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		fontSize: '$md',
		fontWeight: '500',
		color: '$neutral130',
		'&:hover': { cursor: 'pointer' },
	}),
}
